<template>
  <div class="spl-adhoc-drive-list-header">
    <form-button @onClick="handleCreateAdhocDrive">
      Create Adhoc Drive
    </form-button>
    <form-button
      style="grid-column: 3"
      data-cy="adhoc-drive-detail-header-excel"
      @onClick="handleDownload">
      Excel
    </form-button>
    <form-button
      style="grid-column: 4"
      data-cy="adhoc-drive-detail-header-invoiced"
      @onClick="isInvoicedSave">
      Invoiced
    </form-button>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { round } from 'lodash'
import Helpers from '@/helpers.vue'

export default {
  mixins: [Helpers],
  computed: {
    ...mapGetters('adhocDrive', ['adhocDriveList'])
  },
  methods: {
    ...mapActions('adhocDrive', ['updateAdhocDrive']),
    handleCreateAdhocDrive () {
      this.$router.push('/adhoc-drive-create')
    },
    handleDownload () {
      var excelList = {
        Columns: [],
        Rows: [],
        Filter: {
        }
      }
      var selectedFields = [
        { name: 'Counter_Number', label: 'Counter Number', type: 'String' },
        { name: 'Customer_Name', label: 'Customer', type: 'String' },
        { name: 'Country_Name', label: 'Country', type: 'String' },
        { name: 'Provider_Name', label: 'Provider', type: 'String' },
        { name: 'Date_Of_Order', label: 'Date', type: 'Date' },
        { name: 'From_City', label: 'From City', type: 'String' },
        { name: 'To_City', label: 'To City', type: 'String' },
        { name: 'Description', label: 'Description', type: 'String' },
        { name: 'Number_Of_Parcels', label: 'Parcels', type: 'Number' },
        { name: 'Weight', label: 'Weight', type: 'Number.2' },
        { name: 'Cost_Coverage_By', label: 'Cost Coverage By', type: 'String' },
        { name: 'Agreed_Cost', label: 'Agreed_Cost', type: 'Number' },
        { name: 'Agreed_Price', label: 'Agreed_Price', type: 'Number' },
        { name: 'Currency_Name', label: 'Currency', type: 'String' },
        { name: 'Comments', label: 'Comments', type: 'String' }
      ]
      // Loop through the columns and add them to excel object
      for (let i = 0; i < selectedFields.length; i++) {
        const field = selectedFields[i]
        excelList.Columns.push({ ID: field.name, Header: field.label, Type: this.getColumnType(field.type) })
      }

      const results = this.adhocDriveList
      // add the values
      for (let i = 0; i < results.length; i++) {
        var rowValues = { Value: [] }
        const result = results[i]
        for (let j = 0; j < selectedFields.length; j++) {
          const field = selectedFields[j]
          rowValues.Value.push(this.formatField(result[field.name], field.type, field.name))
        }
        excelList.Rows.push(rowValues)
      }
      // Call the excel download helper
      this.getexcelDownload(excelList, 'AdhocDrives.xlsx')
    },
    isInvoicedSave () {
      this.updateAdhocDrive(this.adhocDriveList)
    },
    getColumnType (fieldType) {
      // Converts the formats into excel compatible ones
      // "Number", "DateTime", "Text", "Boolean"
      if (fieldType) {
        switch (fieldType) {
          case 'Number':
          case 'Number.3':
            return 'Number'
          case 'Number.2':
            return 'Number.2'

          case 'Boolean' :
            return 'Boolean'

          case 'Date':
          case 'Timestamp':
            return 'DateTime'

          case 'String':
          default:
            return 'Text'
        }
      }
      return ''
    },
    // Special formatting for fields
    formatField (field, type, name) {
      // empty fields will be removed
      if (field === null) {
        return ''
      }
      switch (type) {
        case 'Number.2':
          return round(field, 2).toFixed(2)
        case 'Number.3' :
          return round(field, 3).toFixed(3)
        case 'Date':
          return this.formatDate(field, false, 'YYYY-MM-DD')
        case 'Timestamp':
          return this.formatDate(field, true, 'YYYY-MM-DD HH:mm')
      }
      return field
    }
  }
}
</script>

<style lang="scss">
  @import '../../../variables.scss';

  .spl-adhoc-drive-list-header {
    position: relative;
    padding: 0 $mainPadding;
    margin: 15px 0;
  }

</style>
